export const createPermissionChecker =
  (featureList: string[] = []) =>
  (feature: string) =>
    featureList.includes(feature);
